import Cookies from 'js-cookie';

const StoreInLocalStorage = 0;
const StoreInCookie = 1;


export default class UserDataService {
    saveData(responseUserData) {
        if (responseUserData == null || !Array.isArray(responseUserData)) {
            return;
        }

        for (let i=0 ; i<responseUserData.length ; i++) {
            let userData = responseUserData[i];
            if (userData.storeIn === StoreInCookie) {
                this._saveCookieData(userData);
            }
            else if (userData.storeIn === StoreInLocalStorage) {
                this._saveLocalStorageData(userData);
            }
                        
        }
    }

    _saveCookieData(userData) {
        for (let key in userData.data) {
            if(!userData.data.hasOwnProperty(key)) continue;
            Cookies.set(key, userData.data[key]);
        }
    }

    _saveLocalStorageData(userData) {
        if (!localStorage) return;

        for (let key in userData.data) {
            if(!userData.data.hasOwnProperty(key)) continue;
            localStorage.setItem(key, userData.data[key]);
        }
    }
}